import { randomUUID } from 'utils/random';
import { loadState, saveState } from 'utils/storage';
import { ScenarioPlan } from 'views/playground/features/scenario-planner-2.0/types/scenario-plan.type';

export const getScenarioPlan = async (): Promise<ScenarioPlan> => {
  const raw = loadState({ key: 'getPlaygroundScenarioPlan', storage: 'session' });

  const parsed = (typeof raw === 'string' ? JSON.parse(raw) : raw) as ScenarioPlan; // try to parse safely

  const scenarioPlan = { ...parsed, id: !!parsed.id ? parsed.id : randomUUID() }; // create id if none exists

  saveState({ key: 'getPlaygroundScenarioPlan', storage: 'session', state: { ...scenarioPlan } });

  return scenarioPlan;
};
